import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { debounceTime, distinctUntilChanged } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-permissions',
  template: `
    <div class="d-flex mt-0 mt-md-4">
      <div class="flex-fill">
        <h1 class="mt-2 mt-md-0">Permisos del Sistema</h1>
      </div>
    </div>
    <div class="d-flex mt-4">
      <div class="me-3 d-none d-md-block">
        <ul #subnav app-nav-administration [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-auto">
        <div class="d-flex">
          <div class="flex-fill ms-3 me-3">
            <div class="input-group mb-3">
              <input 
                class="form-control border-secondary border-end-0 rounded-start-3 bg-transparent" 
                placeholder="Buscar permisos..." 
                [formControl]="search">
              <div class="input-group-append border border-secondary border-start-0 rounded-end-3 bg-transparent">
                <fa-icon 
                  [icon]="icons.faSearch" 
                  *ngIf="!search.value" 
                  class="input-group-text bg-transparent border-0 mt-1">
                </fa-icon>
                <fa-icon 
                  [icon]="icons.faTimes" 
                  *ngIf="search.value" 
                  (click)="clearSearch()" 
                  class="input-group-text bg-transparent border-0 mt-1">
                </fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="list-group rounded-4 rounded-md-5 mt-4">
          <div class="list-group-item table-responsive py-4">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-left-3 py-2 ps-3">
                    Módulo
                  </th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">
                    Permiso
                  </th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light py-2">
                    Descripción
                  </th>
                  <th scope="col" class="text-start bg-zazz align-items-center align-middle text-light rounded-top-right-3 py-2">
                    Código
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let permission of filteredPermissions | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: totalPermissions }">
                  <td class="align-middle">{{permission.module}}</td>
                  <td class="align-middle">{{permission.name}}</td>
                  <td class="align-middle">{{permission.description}}</td>
                  <td class="align-middle"><code>{{permission.code}}</code></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="loading">
            <fa-icon [icon]="icons.faCircleNotch" size="2x" animation="spin" class="text-secondary"></fa-icon>
            <p class="text-muted">Cargando...</p>
          </div>
          <div class="list-group-item text-center py-5" *ngIf="!loading && filteredPermissions.length === 0">
            <img src="/assets/images/empty-state.png" width="240px">
            <h5 class="text-muted">No se encontraron permisos</h5>
          </div>
          <div class="list-group-item text-center pt-3" *ngIf="filteredPermissions.length > 0">
            <pagination-controls
              (pageChange)="pageChanged($event)"
              previousLabel="Prev."
              nextLabel="Sig."
              screenReaderPaginationLabel="Pagination"
              screenReaderPageLabel="page"
            ></pagination-controls>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    code {
      background: #f8f9fa;
      padding: 2px 6px;
      border-radius: 4px;
      color: #e83e8c;
    }
  `]
})
export class IndexPermissionsComponent {
  currentView: string = 'permissions';
  loading: boolean = false;
  permissions: any[] = [
    {
      module: 'Órdenes de Compra',
      name: 'Cambiar Estado',
      description: 'Permite cambiar el estado de una orden de compra',
      code: 'purchase_orders.change_status'
    },
    {
      module: 'Órdenes de Compra',
      name: 'Aprobar',
      description: 'Permite aprobar órdenes de compra',
      code: 'purchase_orders.approve'
    },
    // Add more permissions here
  ];
  filteredPermissions: any[] = [];
  search: FormControl = new FormControl('');
  p: number = 1;
  payload = {
    page: 1,
    per_page: 10
  };

  get totalPermissions(): number {
    return this.filteredPermissions.length;
  }

  constructor(
    public icons: IconsService,
    private toastr: ToastrService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.loadPermissions();
    
    this.search.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(term => {
      this.filterPermissions(term);
    });
  }

  loadPermissions() {
    this.loading = true;
    // Initially, set filtered permissions to all permissions
    this.filteredPermissions = [...this.permissions];
    this.loading = false;
  }

  filterPermissions(term: string) {
    if (!term) {
      this.filteredPermissions = [...this.permissions];
      return;
    }

    this.filteredPermissions = this.permissions.filter(permission =>
      permission.name.toLowerCase().includes(term.toLowerCase()) ||
      permission.code.toLowerCase().includes(term.toLowerCase()) ||
      permission.module.toLowerCase().includes(term.toLowerCase()) ||
      permission.description.toLowerCase().includes(term.toLowerCase())
    );
  }

  pageChanged(event: number) {
    this.p = event;
    this.payload.page = event;
  }

  clearSearch() {
    this.search.setValue('');
  }
}
